module.exports = __webpack_public_path__ + "img/img_mainland_account_open_8.7255114b.png";